import UserError from './UserError.js'

/**
 * Error for GetBuyerIntentionsUserUseCase
 */
export default class GetBuyerIntentionsUserError extends UserError {
  /**
   * Create a generic error
   * @param {string} message
   * @returns {GetBuyerIntentionsUserError}
   */
  static create(message) {
    return new GetBuyerIntentionsUserError(message)
  }

  /**
   * Create a not found error
   * @returns {GetBuyerIntentionsUserError}
   */
  static createNotFound() {
    return new GetBuyerIntentionsUserError('Buyer intentions not found')
  }

  /**
   * Create a no content error
   * @returns {GetBuyerIntentionsUserError}
   */
  static createNoContent() {
    return new GetBuyerIntentionsUserError('No buyer intentions available')
  }
}
